export default __webpack_public_path__ + "static/pt_sam42_manualwork-d3e9969dc816364fc41d1aa50447c1bc.jpg";